import { CRUDEntity } from "../../abstracts/CRUDEntity";


export class InformationSettings extends CRUDEntity{

    constructor(){
        super();
        this.entityClass = 'information-setting';
        this.urlRoot = '/settings';
        this.sectionRootUrl = '/settings';

    }
}
